import React, { Component } from "react";
import { flushSync } from "react-dom";
import { BlobServiceClient } from "@azure/storage-blob";
import { azureBlobs, bmpCount } from "../App";
import { cmsAccount, msHeaders, jsonHeaders } from "../components/NavMenu";
import { DeviceModal } from "../components/DeviceModal";
import { IconButton } from "../components/IconButton";
import { MyDropzone } from "../components/MyDropzone";
import { PictureBox } from "../components/PictureBox";
import { Previewer } from "../components/Previewer";
import { PictureDrawer } from "../components/PictureDrawer";
import { PlaylistTool } from "../components/PlaylistTool";
import { Seperator } from "../components/Seperator";
import JSZip from "jszip";
import "./css/Playlist.css";

export class Playlist extends Component {
    constructor(props) {
        super(props);
        this.modelRef = React.createRef();
        this.ortRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.containerClient = null;

        this.state = {
            images: [],
            filterdImages: [],
            playlists: [],
            selectedFiles: [],
            selectedPlaylist: null,
            selectedPlaylistName: "",
            playlistImages: [],
            modalActive: false,
            model: "",
            orientation: "",
            modelMenuActive: false,
            ortMenuActive: false,
            previewerActive: false,
            testImages: [],
            createZipEnabled: false,
        };
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
        const intervalId = setInterval(() => {
            flushSync(() => {
                this.setState({ images: azureBlobs });
            });
            this.imageFilter(this.state.selectedPlaylist);
            if (azureBlobs.length >= bmpCount && bmpCount != 0) {
                clearInterval(intervalId);
            }
        }, 1000);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    /**
     * Do if clicked on outside of element
     */
    handleClickOutside(event) {
        if (this.modelRef && !this.modelRef.current.contains(event.target)) {
            this.setState({ modelMenuActive: false });
        }
        if (this.ortRef && !this.ortRef.current.contains(event.target)) {
            this.setState({ ortMenuActive: false });
        }
    }

    updateImages(imgObj, method) {
        const { selectedPlaylist } = this.state;
        if (method == "delete") {
            const toDelete = azureBlobs.findIndex((i) => i.name == imgObj);
            azureBlobs.splice(toDelete, 1);
            flushSync(() => {
                this.setState({ images: azureBlobs });
            });
            this.imageFilter(selectedPlaylist);
        } else {
            azureBlobs.push(imgObj);
            flushSync(() => {
                this.setState({ images: azureBlobs });
            });
            this.imageFilter(null);
        }
    }

    async playlistClick(uuid) {
        const { createZipEnabled, selectedPlaylist } = this.state;
        if (createZipEnabled) {
            if (window.confirm("You have unsaved changes. Do you want to continue editing?")) {
                return;
            }
        }
        this.setState({
            selectedPlaylist: uuid,
            selectedFiles: [],
        });

        this.getPlaylistContent(uuid);
        this.imageFilter(uuid);
    }

    fileClick(file) {
        const { selectedFiles } = this.state;
        let exist = false;
        selectedFiles.find(function (item, index) {
            if (item === file) {
                selectedFiles.splice(index, 1);
                exist = true;
            }
        });

        if (!exist) {
            selectedFiles.push(file);
        }
        this.setState({ selectedFiles: selectedFiles });
    }

    addImages() {
        const { selectedFiles, selectedPlaylist, playlistImages } = this.state;

        if (!selectedFiles.length) {
            alert("Select images to add to playlist.");
            return;
        }

        if (selectedPlaylist == null) {
            alert("Select a playlist to add images.");
            return;
        }
        const tmpImages = playlistImages;

        selectedFiles.forEach((f) => {
            console.log(playlistImages);
            tmpImages.push(f);
        });
        this.setState({
            playlistImages: tmpImages,
            selectedFiles: [],
            createZipEnabled: true,
        });
    }

    deleteImage(files) {
        this.setState({ selectedFiles: [] });
        files.forEach((file) => {
            var formdata = new FormData();
            formdata.append("companyUUID", cmsAccount.companyUUID);

            var requestOptions = {
                method: "DELETE",
                headers: msHeaders,
                body: formdata,
                redirect: "follow",
            };

            fetch(`/api/images/${file.name}`, requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    this.updateImages(file.name, "delete");
                })
                .catch((error) => console.log("error", error));
        });
    }

    deleteImageInPlaylist(id) {
        const { selectedPlaylist, playlistImages } = this.state;
        let tempImages = playlistImages;

        tempImages.splice(id, 1);
        this.setState({
            playlistImages: tempImages,
            createZipEnabled: true,
        });
    }

    async getPlaylistContent(uuid) {
        if (!uuid) return;
        this.setState({
            playlistImages: [],
            createZipEnabled: false,
        });

        var requestOptions = {
            method: "GET",
            headers: jsonHeaders,
            redirect: "follow",
        };

        const [playlistResponse, zipResponse, picturesResponse] = await Promise.all([
            fetch(`/api/playlists/${uuid}`, requestOptions),
            fetch(`/api/playlists/${uuid}/zip`, requestOptions),
            fetch(`/api/playlists/${uuid}/pictures`, requestOptions),
        ]);

        const [playlistResult, zipResult, picturesResult] = await Promise.all([
            playlistResponse.json(),
            zipResponse.json(),
            picturesResponse.json(),
        ]);

        this.setState({
            selectedPlaylistName: playlistResult.name,
            model: playlistResult.model,
            orientation:
                playlistResult.orientation == 0 || playlistResult.orientation == 180
                    ? `Landscape (${playlistResult.orientation}°)`
                    : `Portrait (${playlistResult.orientation}°)`,
        });

        if (zipResult.status == 404) {
            return;
        }

        const response = await fetch(zipResult.url);
        const zipFile = await response.arrayBuffer();
        const zip = await JSZip.loadAsync(zipFile);
        const zipFiles = await this.processZipEntries(zip);

        picturesResult.forEach((image) => {
            const source = zipFiles.find((f) => f.name == image.name);
            image.imageSrc = URL.createObjectURL(source.data);
        });
        this.setState({ playlistImages: picturesResult });
    }

    async processZipEntries(zip) {
        const promises = [];
        zip.forEach((relativePath, zipEntry) => {
            if (!zipEntry.dir) {
                const promise = zipEntry.async("blob").then((blob) => {
                    console.log(zipEntry.name);
                    return {
                        name: zipEntry.name,
                        data: blob,
                    };
                });
                promises.push(promise);
            }
        });
        return Promise.all(promises);
    }

    imageFilter(playlistId) {
        const { images } = this.state;
        if (!playlistId) {
            this.setState({ filterdImages: images });
            return;
        }
        var requestOptions = {
            method: "GET",
            headers: jsonHeaders,
            redirect: "follow",
        };
        fetch(`/api/playlists/${playlistId}`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                const ort = result.orientation;
                let tmpImages = [];
                if (ort == 0 || ort == 180) {
                    images.forEach(function (image) {
                        if (image.orientation == "Landscape") {
                            tmpImages.push(image);
                        }
                    });
                } else {
                    images.forEach(function (image, i) {
                        if (image.orientation == "Portrait") {
                            tmpImages.push(image);
                        }
                    });
                }
                this.setState({ filterdImages: tmpImages });
            });
    }

    selectOrt(orientation) {
        console.log(orientation);
        const { selectedPlaylist } = this.state;
        var formdata = new FormData();
        formdata.append("orientation", orientation);

        var requestOptions = {
            method: "PATCH",
            headers: msHeaders,
            body: formdata,
            redirect: "follow",
        };

        fetch(`/api/playlists/${selectedPlaylist}/orientation`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (orientation % 180 == 0) this.setState({ orientation: `Landscape (${orientation}°)` });
                else this.setState({ orientation: `Portrait (${orientation}°)` });

                this.setState({ ortMenuActive: false });
                this.imageFilter(selectedPlaylist);
            })
            .catch((error) => console.log("error", error));
    }

    selectModel(model) {
        const { selectedPlaylist } = this.state;
        var formdata = new FormData();
        formdata.append("model", model);

        var requestOptions = {
            method: "PUT",
            body: formdata,
            redirect: "follow",
        };

        fetch(`/api/playlists/${selectedPlaylist}/model`, requestOptions)
            .then((response) => response.text())
            .then((result) => {
                this.setState({
                    model: model,
                    modelMenuActive: false,
                });
                this.imageFilter(selectedPlaylist);
            })
            .catch((error) => console.log("error", error));
    }

    async createZip(playlistId) {
        if (!playlistId) return;
        const imageNames = this.state.playlistImages.map((item) => item.name);
        if (imageNames.length > 50) {
            alert("Please upload a maximum of 50 images at a time.");
            return;
        }
        this.setState({ createZipEnabled: false });
        var requestOptions = {
            method: "PUT",
            headers: jsonHeaders,
            body: JSON.stringify({ imageNames }),
            redirect: "follow",
        };
        await fetch(`/api/playlists/${playlistId}/pictures`, requestOptions);
    }

    render() {
        const {
            filterdImages,
            selectedFiles,
            selectedPlaylist,
            selectedPlaylistName,
            playlistImages,
            modalActive,
            model,
            orientation,
            modelMenuActive,
            ortMenuActive,
            previewerActive,
            createZipEnabled,
        } = this.state;
        return (
            <>
                <div className="playlist-page">
                    <div className="picture-manager-container">
                        <div className="file-drag-zone">
                            <MyDropzone
                                updateImages={(imgObj) => {
                                    this.updateImages(imgObj, "add");
                                }}
                                containerClient={this.containerClient}
                            />
                            <div className="outfit-text drag-text">drag pictures here</div>
                            <div className="outfit-text or-text">or</div>
                            <div className="add-picture-button outfit-text">Add pictures</div>
                            <div className="outfit-text req-text">
                                <br />
                                Image format: JPG/JPEG/JFIF/PNG/BMP
                                <br />
                                Image will be auto-cropped to 2560x1440
                            </div>
                        </div>
                        <div className="picture-drawer">
                            <div className="top-bar">
                                <div className="tool-bar">
                                    <IconButton
                                        onClick={() => {
                                            this.deleteImage(selectedFiles);
                                        }}
                                        src="icons/delete.svg"
                                        srcWhite="icons/delete-white.svg"
                                    />
                                    {/* <IconButton
                                        onClick={() => { }}
                                        src="icons/edit.svg"
                                        srcWhite="icons/edit-white.svg"
                                    /> */}
                                </div>
                            </div>
                            <PictureDrawer
                                images={filterdImages}
                                selectedFiles={selectedFiles}
                                fileClick={(image) => {
                                    this.fileClick(image);
                                }}
                            />
                            <div className="bottom-bar">
                                <div className="info-12pt">
                                    <div className="info-text">
                                        Selected: {selectedFiles.length}/{filterdImages.length}
                                    </div>
                                </div>
                                <div
                                    className="add-to-playlist-button"
                                    onClick={() => {
                                        this.addImages();
                                    }}
                                >
                                    Add to Playlist
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="page-seperator">
                        <div className="line-1"></div>
                    </div>
                    {this.state.testImages.map((item) => {
                        return (
                            <>
                                <img src={URL.createObjectURL(item.data)} width={150} />
                            </>
                        );
                    })}
                    <div className="playlist-editor-container">
                        <PlaylistTool
                            selectedPlaylist={selectedPlaylist}
                            playlistClick={(uuid) => {
                                this.playlistClick(uuid);
                            }}
                            openPreviewer={() => {
                                this.setState({ previewerActive: true });
                            }}
                        />
                        <div className="playlist-editor">
                            <div className="tool-bar">
                                <div
                                    className="model-selector"
                                    onClick={() => {
                                        this.setState({ modelMenuActive: true });
                                    }}
                                >
                                    <div className="selector">
                                        <div className="text" id="model-text">
                                            {model}
                                        </div>
                                        <img src="/icons/arrow-down-big.svg" className="component-1" />
                                    </div>
                                    <div
                                        className="model-menu menu"
                                        id="model-menu"
                                        ref={this.modelRef}
                                        style={{ display: modelMenuActive ? "flex" : "none" }}
                                    >
                                        {/* <div className="text" onClick={() => { this.selectModel('CP-25.3 / Kaleido / 25.3” / 3200 x 1800') }}>
                                            CP-25.3 / Kaleido / 25.3” / 3200 x 1800
                                        </div> */}
                                        {/* <Seperator width={272} /> */}
                                        <div
                                            className="text"
                                            onClick={() => {
                                                this.selectModel("CP-31.5 / Spectra / 31.5” / 2560 x 1440");
                                            }}
                                        >
                                            CP-31.5 / Spectra / 31.5” / 2560 x 1440
                                        </div>
                                    </div>
                                </div>
                                <Seperator height={32} />
                                <div
                                    className="style-selector"
                                    onClick={() => {
                                        this.setState({ ortMenuActive: true });
                                    }}
                                >
                                    <div className="selector">
                                        <div className="text" id="ort-text">
                                            {orientation}
                                        </div>
                                        <img className="component-1" src="/icons/arrow-down-big.svg" />
                                    </div>
                                    <div
                                        className="ort-menu menu"
                                        id="ort-menu"
                                        ref={this.ortRef}
                                        style={{ display: ortMenuActive ? "flex" : "none" }}
                                    >
                                        <div
                                            className="text"
                                            onClick={() => {
                                                this.selectOrt(0);
                                            }}
                                        >
                                            Landscape (0°)
                                        </div>
                                        <Seperator width={172} />
                                        <div
                                            className="text"
                                            onClick={() => {
                                                this.selectOrt(90);
                                            }}
                                        >
                                            Portrait (90°)
                                        </div>
                                        <Seperator width={172} />
                                        <div
                                            className="text"
                                            onClick={() => {
                                                this.selectOrt(180);
                                            }}
                                        >
                                            Landscape (180°)
                                        </div>
                                        <Seperator width={172} />
                                        <div
                                            className="text"
                                            onClick={() => {
                                                this.selectOrt(270);
                                            }}
                                        >
                                            Portrait (270°)
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <PictureBox
                                images={playlistImages}
                                deleteImage={(index) => {
                                    this.deleteImageInPlaylist(index);
                                }}
                                updateOrder={(newImages) => {
                                    this.setState({
                                        playlistImages: newImages,
                                        createZipEnabled: true,
                                    });
                                }}
                            />
                            <div className="bottom-bar">
                                <div className="edit-name-container">
                                    <div className="edit-title-text">Edit Playlist:</div>
                                    <div className="playlist-name-text">{selectedPlaylistName}</div>
                                    <div className="edit-title-text" style={playlistImages.length > 50 ? { color: "red" } : {}}>
                                        ({playlistImages.length} images)
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    className="btn btn-lg btn-primary assign-button"
                                    disabled={!createZipEnabled}
                                    onClick={() => {
                                        this.createZip(selectedPlaylist);
                                    }}
                                >
                                    Save
                                </button>
                                <div
                                    className="assign-button"
                                    onClick={() => {
                                        this.setState({ modalActive: true });
                                    }}
                                >
                                    Assign Playlist to Devices
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <DeviceModal
                    shown={modalActive}
                    closeModal={() => {
                        this.setState({ modalActive: false });
                    }}
                    playlistId={selectedPlaylist}
                />
                <Previewer
                    shown={previewerActive}
                    pictures={playlistImages}
                    close={() => {
                        this.setState({ previewerActive: false });
                    }}
                />
            </>
        );
    }
}
